module.exports = __webpack_public_path__ + "img/8476e7e.png";